import type { ReactNode } from 'react';
import { Button, Empty } from 'antd';
import { useTranslation } from 'react-i18next';

export interface EmptyStateProps {
  title?: string;
  description?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  const { t } = useTranslation();
  return (
    <Empty
      description={description ?? title ?? t('empty.default')}
      style={{ padding: '40px 0', color: 'var(--color-text-secondary)' }}
    >
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  );
}
